export var QueryParameters;
(function (QueryParameters) {
    QueryParameters["CatalogType"] = "catalog-type";
    QueryParameters["NavigationSource"] = "navigationSource";
    QueryParameters["SearchAnonId"] = "searchAnonId";
    QueryParameters["Reco"] = "reco";
    QueryParameters["SuggestedBrandId"] = "suggestedBrandId";
    QueryParameters["ThemeHash"] = "themeHash";
    QueryParameters["SearchedAt"] = "searchedAt";
})(QueryParameters || (QueryParameters = {}));
export var CatalogType;
(function (CatalogType) {
    CatalogType["TopPicks"] = "top-picks";
    CatalogType["Brand"] = "brand";
    CatalogType["CrossCampaign"] = "cross-campaign";
    CatalogType["Campaign"] = "campaign";
    CatalogType["BiggestDiscount"] = "best_deal_carousel";
    CatalogType["SimilarArticles"] = "similar_articles";
    CatalogType["SacCarousel"] = "sac_carousel";
})(CatalogType || (CatalogType = {}));
export var NavigationSourceType;
(function (NavigationSourceType) {
    NavigationSourceType["BiggestDiscount"] = "best_deal_carousel";
    NavigationSourceType["Highligts"] = "highligts_carousel";
    NavigationSourceType["TopPicks"] = "tp4u";
    NavigationSourceType["SimilarArticles"] = "similar_articles";
    NavigationSourceType["SuggestedBrand"] = "suggested_brand";
    NavigationSourceType["SacCarousel"] = "sac_carousel";
    NavigationSourceType["ResumeSearchCarousel"] = "resume_search_carousel";
    NavigationSourceType["ContinueShopping"] = "continue_shopping";
})(NavigationSourceType || (NavigationSourceType = {}));
export var getCatalogType = function () {
    var catalogTypeParam = new URLSearchParams(window.location.search).get(QueryParameters.CatalogType);
    if (!catalogTypeParam) {
        return null;
    }
    if (Object.values(CatalogType).includes(catalogTypeParam)) {
        return catalogTypeParam;
    }
    return null;
};
